import { createSlice } from '@reduxjs/toolkit';
import { getCompanyById, updateCompanyById } from './companyInfoThunk';

const initialState = {
  data: {
    id: '',
    name: '',
    accountantEmail: '',
    accountantMobileNumber: '',
    businessRegistrationNumber: '',
    note: '',
  },
};

const companyInfoSlice = createSlice({
  name: 'companyInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyById.fulfilled, (state, { payload }) => {
        const {
          id,
          name,
          accountantEmail,
          accountantMobileNumber,
          businessRegistrationNumber,
        } = payload;
        state.data = {
          id,
          name,
          accountantEmail,
          accountantMobileNumber,
          businessRegistrationNumber,
          note: '',
        };
      })
      .addCase(getCompanyById.rejected, (_, { payload }) => {
        throw payload;
      });

    builder
      .addCase(updateCompanyById.fulfilled, (state, { payload }) => {
        state.data = payload;
      })
      .addCase(updateCompanyById.rejected, (_, { payload }) => {
        throw payload;
      });
  },
});

export default companyInfoSlice.reducer;
